/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { KeyValueUUIDString } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce l’elenco delle tipologie di stili associabili all’esito di un task
 * @summary Lista stili
 */
export const getTipiStile = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<KeyValueUUIDString[]>(
    { url: `/framework-cfg-procedimenti/tipi-stile`, method: 'get', signal },
    options,
  );
};

export const getGetTipiStileQueryKey = () =>
  [`/framework-cfg-procedimenti/tipi-stile`] as const;

export const getGetTipiStileQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiStile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiStile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<Awaited<ReturnType<typeof getTipiStile>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiStileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipiStile>>> = ({
    signal,
  }) => getTipiStile(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiStileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiStile>>
>;
export type GetTipiStileQueryError = ErrorType<unknown>;

/**
 * @summary Lista stili
 */
export const useGetTipiStile = <
  TData = Awaited<ReturnType<typeof getTipiStile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiStile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiStileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
